"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupToCols = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _RowList = _interopRequireDefault(require("../../component/RowList"));

var _InfiniteScroller = _interopRequireDefault(require("../../component/InfiniteScroller"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var styles = {
  Grid: {
    display: 'grid',
    padding: 0
  },
  Loading: {
    marginBottom: 50
  }
};

var groupToCols = function groupToCols(numCols) {
  return function groupingFunc(items) {
    var grouped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newItems = items.slice();

    if (!newItems.length) {
      return grouped;
    }

    if (newItems.length < numCols) {
      return [].concat((0, _toConsumableArray2["default"])(grouped), [(0, _toConsumableArray2["default"])(newItems)]);
    }

    var group = newItems.splice(0, numCols);
    grouped.push(group);
    return groupingFunc(newItems, grouped);
  };
};

exports.groupToCols = groupToCols;

var renderListItems = function renderListItems(_ref) {
  var items = _ref.items,
      itemHeight = _ref.itemHeight,
      LoaderComponent = _ref.LoaderComponent,
      ItemComponent = _ref.ItemComponent;
  return items.map(function (item, i) {
    if (item.loading) {
      return /*#__PURE__*/React.createElement(LoaderComponent, {
        key: "loader".concat(i),
        height: itemHeight,
        isEven: i % 2 !== 0
      });
    }

    return /*#__PURE__*/React.createElement(ItemComponent, (0, _extends2["default"])({
      key: "list-item-".concat(item.id || i),
      index: i,
      height: itemHeight,
      isEven: i % 2 === 0
    }, item));
  });
}; // eslint-disable-next-line complexity


var renderFillerLoadingBoxes = function renderFillerLoadingBoxes(row, columns) {
  if (row && row.length && row[0].loading && row.length < columns) {
    for (var i = 0; i < columns - row.length; i++) {
      row.push({
        loading: true
      });
    }
  }
};

var renderGridItems = function renderGridItems(_ref2) {
  var rows = _ref2.rows,
      itemHeight = _ref2.itemHeight,
      rowHeight = _ref2.rowHeight,
      LoaderComponent = _ref2.LoaderComponent,
      columns = _ref2.columns,
      ItemComponent = _ref2.ItemComponent,
      classes = _ref2.classes;
  return rows.map(function (row, rowIndex) {
    renderFillerLoadingBoxes(row, columns);

    try {
      return /*#__PURE__*/React.createElement("div", {
        key: row[0].id || rowIndex,
        className: (0, _classnames["default"])(classes.Grid, 'type-grid'),
        style: {
          gridTemplateColumns: "repeat(".concat(columns, ", 1fr)"),
          height: rowHeight
        }
      }, row.map(function (item, cellIndex) {
        return item.loading ? /*#__PURE__*/React.createElement(LoaderComponent, {
          key: "loader".concat(cellIndex),
          isEven: false,
          height: rowHeight
        }) : /*#__PURE__*/React.createElement(ItemComponent, (0, _extends2["default"])({
          key: "grid-item-".concat(item.id || cellIndex),
          height: itemHeight,
          isEven: cellIndex % 2 === 0,
          index: cellIndex
        }, item));
      }));
    } catch (e) {
      return /*#__PURE__*/React.createElement("div", {
        key: "error-".concat(rowIndex)
      });
    }
  });
};

var useStyles = (0, _ThemeProvider.createUseStyles)(styles);

var handleRender = function handleRender(rowHeights, isGrid, classes, GridComponent, ListComponent, LoaderComponent, columns, displayView, containerTestId, id) {
  return (// eslint-disable-next-line react/display-name
    function (_ref3) {
      var itemHeight = _ref3.itemHeight,
          virtual = _ref3.virtual;
      return /*#__PURE__*/React.createElement(_RowList["default"], {
        type: displayView,
        style: virtual.style,
        id: id,
        "data-test-id": containerTestId,
        className: virtual.items && virtual.items.length && virtual.items[0].loading ? classes.Loading : ''
      }, isGrid ? renderGridItems({
        rows: virtual.items,
        itemHeight: itemHeight,
        rowHeight: rowHeights[1],
        LoaderComponent: LoaderComponent,
        columns: columns,
        ItemComponent: GridComponent,
        classes: classes
      }) : renderListItems({
        items: virtual.items,
        itemHeight: itemHeight,
        LoaderComponent: LoaderComponent,
        ItemComponent: ListComponent
      }));
    }
  );
};

var ListToggle = function ListToggle(_ref4) {
  var _ref4$displayView = _ref4.displayView,
      displayView = _ref4$displayView === void 0 ? 'list' : _ref4$displayView,
      _ref4$columns = _ref4.columns,
      columns = _ref4$columns === void 0 ? 3 : _ref4$columns,
      offsetBy = _ref4.offsetBy,
      listData = _ref4.listData,
      loadMore = _ref4.loadMore,
      GridComponent = _ref4.GridComponent,
      ListComponent = _ref4.ListComponent,
      rowHeights = _ref4.rowHeights,
      totalCount = _ref4.totalCount,
      LoaderComponent = _ref4.LoaderComponent,
      containerHeight = _ref4.containerHeight,
      containerTestId = _ref4.containerTestId,
      onRef = _ref4.onRef,
      id = _ref4.id;
  var classes = useStyles();
  var isGrid = displayView == 'grid';
  var processedListData = React.useMemo(function () {
    return isGrid ? groupToCols(columns)(listData) : listData;
  }, [isGrid, columns, listData]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: containerHeight
    }
  }, /*#__PURE__*/React.createElement(_InfiniteScroller["default"], {
    listData: processedListData,
    refreshToken: processedListData.length,
    offsetBy: offsetBy,
    columns: isGrid ? columns : undefined,
    loadMore: loadMore,
    totalCount: totalCount,
    itemHeight: isGrid ? rowHeights[1] : rowHeights[0],
    onRef: onRef,
    withIndices: false,
    render: handleRender(rowHeights, isGrid, classes, GridComponent, ListComponent, LoaderComponent, columns, displayView, containerTestId, id)
  }));
};

var MemoizedListToggle = React.memo(ListToggle, // eslint-disable-next-line complexity
function (prevProps, nextProps) {
  return (0, _lodash.isEqual)(prevProps.listData, nextProps.listData) && prevProps.columns === nextProps.columns && prevProps.totalCount === nextProps.totalCount && prevProps.displayView === nextProps.displayView && prevProps.GridComponent === nextProps.GridComponent && prevProps.ListComponent === nextProps.ListComponent && prevProps.offsetBy === nextProps.offsetBy;
});
exports["default"] = MemoizedListToggle;
//# sourceMappingURL=ListToggle.js.map